(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ss-ship-timer"] && !Shopify.designMode) return;
  try {
    class SSShipTimer extends HTMLElement {
    connectedCallback() {
      this.hour = parseInt(this.dataset.cutoffHour, 10) || 0;
      this.minute = parseInt(this.dataset.cutoffMinute, 10) || 0;
      this.tz = this.dataset.timezone || 'America/New_York';
      this.weekdaysOnly = this.dataset.weekdaysOnly === 'true';
      this.openEl = this.querySelector('.ss-ship-timer__open');
      this.closedEl = this.querySelector('.ss-ship-timer__closed');
      this.clockEl = this.querySelector('.ss-ship-timer__clock');
      try {
        this.fmt = new Intl.DateTimeFormat('en-US', {
          timeZone: this.tz,
          hour12: false,
          weekday: 'short',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        });
      } catch (e) {
        return;
      }
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      const parts = {};
      for (const p of this.fmt.formatToParts(new Date())) parts[p.type] = p.value;
      const now = (parseInt(parts.hour, 10) % 24) * 3600 + parseInt(parts.minute, 10) * 60 + parseInt(parts.second, 10);
      const cutoff = this.hour * 3600 + this.minute * 60;
      const weekend = parts.weekday === 'Sat' || parts.weekday === 'Sun';
      const open = now < cutoff && !(this.weekdaysOnly && weekend);
      if (open) {
        const left = cutoff - now;
        const h = Math.floor(left / 3600);
        const m = Math.floor((left % 3600) / 60);
        const s = left % 60;
        this.clockEl.textContent = [h, m, s].map((n) => String(n).padStart(2, '0')).join(':');
      }
      this.openEl.hidden = !open;
      this.closedEl.hidden = open;
    }
  }

  if (!customElements.get('ss-ship-timer')) customElements.define('ss-ship-timer', SSShipTimer);
  } catch(e) { console.error(e); }
})();

})();
